import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CompanyInfoProvider } from "@/context/CompanyInfoContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { ConsentProvider } from "@/context/ConsentContext";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Fleet from "@/pages/Fleet";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import NotFound from "@/pages/NotFound";
import Privacy from "@/pages/legal/Privacy";
import Terms from "@/pages/legal/Terms";
import DriverConsent from "@/pages/legal/DriverConsent";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import Shipments from "@/pages/admin/Shipments";
import Drivers from "@/pages/admin/Drivers";
import Trucks from "@/pages/admin/Trucks";
import Trailers from "@/pages/admin/Trailers";
import Customers from "@/pages/admin/Customers";
import QuoteInbox from "@/pages/admin/QuoteInbox";
import Applications from "@/pages/admin/Applications";
import Messages from "@/pages/admin/Messages";
import CompanyInfo from "@/pages/admin/CompanyInfo";
import ContentManager from "@/pages/admin/ContentManager";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[var(--lt-bg)] text-slate-400 font-head uppercase tracking-widest">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <CompanyInfoProvider>
        <ThemeProvider>
        <BrowserRouter>
        <ConsentProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/fleet" element={<Fleet />} />
            <Route path="/careers" element={<Contact initialMode="driver" />} />
            <Route path="/contact" element={<Contact initialMode="message" />} />
            <Route path="/quote" element={<Contact initialMode="quote" />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy-policy" element={<Navigate to="/privacy" replace />} />
            <Route path="/terms-and-conditions" element={<Navigate to="/terms" replace />} />
            <Route path="/driver-consent" element={<DriverConsent />} />
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<NotFound />} />
          </Route>

          <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
            <Route index element={<Overview />} />
            <Route path="shipments" element={<Shipments />} />
            <Route path="drivers" element={<Drivers />} />
            <Route path="trucks" element={<Trucks />} />
            <Route path="trailers" element={<Trailers />} />
            <Route path="customers" element={<Customers />} />
            <Route path="quotes" element={<QuoteInbox />} />
            <Route path="applications" element={<Applications />} />
            <Route path="messages" element={<Messages />} />
            <Route path="company" element={<CompanyInfo />} />
            <Route path="content" element={<ContentManager />} />
          </Route>
        </Routes>
        </ConsentProvider>
      </BrowserRouter>
      </ThemeProvider>
      </CompanyInfoProvider>
    </AuthProvider>
  );
}

export default App;
